export default __webpack_public_path__ + "static/media/2db3933934719fb1.c0cb6a65741c22c0ef57a8854fc0d105.svg";